module.exports = __webpack_public_path__ + "static/img/Serve10@2x.3fadd55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Serve10@2x.png
// module id = NqW2
// module chunks = 1